import React, { useState } from 'react';
import DataTable from '../../components/DataTable';
import PageWrapper from '../../components/PageWrapper';
import { useTableDataWithPost } from '../../hooks/useTableWithPost';
import { CommissionTypeManagement } from '../../config/tableConfigs';
import PageWrapperForm from '../../components/PageWrapperForm';
import SchemeFormModal from './components/schemeFormModal'; // ✅ fixed
import DeleteModal from '../../components/DeleteModal';
import CommissionTypeFormModal from './components/CommissionTypeFormModal';
import { useSession } from 'hooks/useSession';

const CommissionTypeManagementPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0); 
  const {userid}= useSession();
  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/commission_type_manager_action",
    CommissionTypeManagement,
    formdata, 
    refresh
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deletecommission1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)
    ) {
      console.log("Deleting selected records:", selectedIds);
    }
  };
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Custom Header Layout */}
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>Commission Type Management</h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="ph-duotone ph-percent f-s-16"></i> <span className="ms-1">Commission</span>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2" }}>
                  Type Management
                </a>
              </div>
            </div>

            <div>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center px-4"
                onClick={handleAddUser}
                style={{
                  backgroundColor: "#7e57c2", borderColor: "#7e57c2", borderRadius: "8px", height: "44px", width: "fit-content", minWidth: "160px"
                }}
              >
                <i className="iconoir-plus-circle me-2" style={{ fontSize: "20px" }}></i>
                <span className="fw-medium text-nowrap">Add Commission Type</span>
              </button>
            </div>
          </div>
        </div>

        {/* Card Body */}
        <div className="row m-1">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" }}>
              <div className="card-body p-4">
                <DataTable
                  config={CommissionTypeManagement}
                  tableData={tableData}
                  onView={handleView}
                  onEdit={handleEditUser}
                  onDelete={handleDelete}
                  onExport={handleExport}
                  onDeleteSelected={handleDeleteSelected}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Fixed modal usage */}
      <CommissionTypeFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
      deleteid={selectedUser}

        id="deletecommission1"
        title="Delete Commission Type"
        message="Are you sure you want to delete this commission type?"
        apiUrl="https://pro.mokshiq.in/commission_type_manager_action"
        onSuccess={handleDeleteSuccess}
      />
    </main>
  );
};

export default CommissionTypeManagementPage;
